import { forwardRef } from 'react';
import type {
  TextControlBaseInstance,
  TextControlProps
} from '@elfsight/widget-ui';
import { TextControl } from '@elfsight/widget-ui';
import { createReadableClass } from '@elfsight/widget-utils';
import { commonFieldsSettings } from '../commonFieldSettings';
import type { CommonFieldProps } from '../types';

export type ShortTextProps = TextControlProps &
  CommonFieldProps<string, HTMLTextAreaElement | HTMLInputElement>;

export const ShortText = forwardRef<TextControlBaseInstance, ShortTextProps>(
  (
    {
      value,
      label,
      showLabel = true,
      fieldLabelColor = commonFieldsSettings.fieldLabelColor,
      fieldLabelPosition = commonFieldsSettings.fieldLabelPosition,
      fieldLabelFontStyle = commonFieldsSettings.fieldLabelFontStyle,
      fieldColor = commonFieldsSettings.fieldColor,
      fieldFillColor = commonFieldsSettings.fieldFillColor,
      fieldFontStyle = commonFieldsSettings.fieldFontStyle,
      fieldBorderType = commonFieldsSettings.fieldBorderType,
      fieldBorderColor = commonFieldsSettings.fieldBorderColor,
      fieldBorderWidth = commonFieldsSettings.fieldBorderWidth,
      fieldBorderRadius = commonFieldsSettings.fieldBorderRadius,
      onChange,
      ...forwardingProps
    },
    forwardingRef
  ) => {
    const ariaLabel = typeof label === 'string' ? label : undefined;

    return (
      <TextControl
        {...forwardingProps}
        ref={forwardingRef}
        value={value}
        className={createReadableClass({
          component: 'fields',
          element: 'short-text'
        })}
        initialValue={value}
        ariaLabel={ariaLabel}
        label={showLabel && fieldLabelPosition === 'inside' ? label : undefined}
        labelColor={fieldLabelColor}
        labelFont={fieldLabelFontStyle}
        color={fieldColor}
        background={fieldFillColor}
        font={fieldFontStyle}
        borderType={fieldBorderType ? fieldBorderType : undefined}
        borderColor={fieldBorderColor}
        borderWidth={fieldBorderWidth}
        borderRadius={fieldBorderRadius}
        onValueChange={onChange}
      />
    );
  }
);
